export { BaseChartComponent } from './base-chart';
